export default __webpack_public_path__ + "static/media/ryzen5.6f2cbe76.png";